/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DashboardDto } from '../models/dashboard-dto';
import { dashboardFavoritesDashboardIdOrganizationPost } from '../fn/dashboard-favorites/dashboard-favorites-dashboard-id-organization-post';
import { DashboardFavoritesDashboardIdOrganizationPost$Params } from '../fn/dashboard-favorites/dashboard-favorites-dashboard-id-organization-post';
import { dashboardFavoritesDashboardIdUserPost } from '../fn/dashboard-favorites/dashboard-favorites-dashboard-id-user-post';
import { DashboardFavoritesDashboardIdUserPost$Params } from '../fn/dashboard-favorites/dashboard-favorites-dashboard-id-user-post';
import { dashboardFavoritesOrganizationGet$Json } from '../fn/dashboard-favorites/dashboard-favorites-organization-get-json';
import { DashboardFavoritesOrganizationGet$Json$Params } from '../fn/dashboard-favorites/dashboard-favorites-organization-get-json';
import { dashboardFavoritesOrganizationGet$Plain } from '../fn/dashboard-favorites/dashboard-favorites-organization-get-plain';
import { DashboardFavoritesOrganizationGet$Plain$Params } from '../fn/dashboard-favorites/dashboard-favorites-organization-get-plain';
import { dashboardFavoritesUserGet$Json } from '../fn/dashboard-favorites/dashboard-favorites-user-get-json';
import { DashboardFavoritesUserGet$Json$Params } from '../fn/dashboard-favorites/dashboard-favorites-user-get-json';
import { dashboardFavoritesUserGet$Plain } from '../fn/dashboard-favorites/dashboard-favorites-user-get-plain';
import { DashboardFavoritesUserGet$Plain$Params } from '../fn/dashboard-favorites/dashboard-favorites-user-get-plain';

@Injectable({ providedIn: 'root' })
export class DashboardFavoritesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `dashboardFavoritesDashboardIdUserPost()` */
  static readonly DashboardFavoritesDashboardIdUserPostPath = '/dashboard-favorites/{dashboardId}/user';

  /**
   * Set user favorite dashboard.
   *
   * Marks/unmarks a dashboard as favorite for current user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardFavoritesDashboardIdUserPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardFavoritesDashboardIdUserPost$Response(params: DashboardFavoritesDashboardIdUserPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = dashboardFavoritesDashboardIdUserPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Set user favorite dashboard.
   *
   * Marks/unmarks a dashboard as favorite for current user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardFavoritesDashboardIdUserPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardFavoritesDashboardIdUserPost(params: DashboardFavoritesDashboardIdUserPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.dashboardFavoritesDashboardIdUserPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `dashboardFavoritesDashboardIdOrganizationPost()` */
  static readonly DashboardFavoritesDashboardIdOrganizationPostPath = '/dashboard-favorites/{dashboardId}/organization';

  /**
   * Set organization favorite dashboard.
   *
   * Marks/unmarks a dashboard as favorite at organization level.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardFavoritesDashboardIdOrganizationPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardFavoritesDashboardIdOrganizationPost$Response(params: DashboardFavoritesDashboardIdOrganizationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = dashboardFavoritesDashboardIdOrganizationPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Set organization favorite dashboard.
   *
   * Marks/unmarks a dashboard as favorite at organization level.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardFavoritesDashboardIdOrganizationPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardFavoritesDashboardIdOrganizationPost(params: DashboardFavoritesDashboardIdOrganizationPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.dashboardFavoritesDashboardIdOrganizationPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `dashboardFavoritesUserGet()` */
  static readonly DashboardFavoritesUserGetPath = '/dashboard-favorites/user';

  /**
   * Get user favorite dashboards.
   *
   * Returns dashboards favorited by the current user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardFavoritesUserGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardFavoritesUserGet$Plain$Response(params?: DashboardFavoritesUserGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DashboardDto>>> {
    const obs = dashboardFavoritesUserGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get user favorite dashboards.
   *
   * Returns dashboards favorited by the current user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardFavoritesUserGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardFavoritesUserGet$Plain(params?: DashboardFavoritesUserGet$Plain$Params, context?: HttpContext): Observable<Array<DashboardDto>> {
    const resp = this.dashboardFavoritesUserGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DashboardDto>>): Array<DashboardDto> => r.body)
    );
  }

  /**
   * Get user favorite dashboards.
   *
   * Returns dashboards favorited by the current user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardFavoritesUserGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardFavoritesUserGet$Json$Response(params?: DashboardFavoritesUserGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DashboardDto>>> {
    const obs = dashboardFavoritesUserGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get user favorite dashboards.
   *
   * Returns dashboards favorited by the current user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardFavoritesUserGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardFavoritesUserGet$Json(params?: DashboardFavoritesUserGet$Json$Params, context?: HttpContext): Observable<Array<DashboardDto>> {
    const resp = this.dashboardFavoritesUserGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DashboardDto>>): Array<DashboardDto> => r.body)
    );
  }

  /** Path part for operation `dashboardFavoritesOrganizationGet()` */
  static readonly DashboardFavoritesOrganizationGetPath = '/dashboard-favorites/organization';

  /**
   * Get organization favorite dashboards.
   *
   * Returns dashboards marked as favorite at organization level.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardFavoritesOrganizationGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardFavoritesOrganizationGet$Plain$Response(params?: DashboardFavoritesOrganizationGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DashboardDto>>> {
    const obs = dashboardFavoritesOrganizationGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get organization favorite dashboards.
   *
   * Returns dashboards marked as favorite at organization level.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardFavoritesOrganizationGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardFavoritesOrganizationGet$Plain(params?: DashboardFavoritesOrganizationGet$Plain$Params, context?: HttpContext): Observable<Array<DashboardDto>> {
    const resp = this.dashboardFavoritesOrganizationGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DashboardDto>>): Array<DashboardDto> => r.body)
    );
  }

  /**
   * Get organization favorite dashboards.
   *
   * Returns dashboards marked as favorite at organization level.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardFavoritesOrganizationGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardFavoritesOrganizationGet$Json$Response(params?: DashboardFavoritesOrganizationGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DashboardDto>>> {
    const obs = dashboardFavoritesOrganizationGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get organization favorite dashboards.
   *
   * Returns dashboards marked as favorite at organization level.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardFavoritesOrganizationGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardFavoritesOrganizationGet$Json(params?: DashboardFavoritesOrganizationGet$Json$Params, context?: HttpContext): Observable<Array<DashboardDto>> {
    const resp = this.dashboardFavoritesOrganizationGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DashboardDto>>): Array<DashboardDto> => r.body)
    );
  }

}
